export {};

var pluginName = 'SectionLoader',
	defaults = {
		selectorList: [],
	};

function SectionLoader(element, options) {
	this.element = element;

	this.options = $.extend({}, defaults, options);

	this._defaults = defaults;
	this._name = pluginName;
}

SectionLoader.prototype = {
	ajaxPageLoaded: function (e, data) {
		var content = $(data),
			doc = $(document);
		if (this.options.selectorList.length > 0) {
			$.each(this.options.selectorList, function (i, el) {
				var tmpContent = '';
				if (typeof el == 'string') {
					var tmpEl = content.find(el);
					if (tmpEl.length > 0) {
						tmpContent = tmpEl.html();
						doc.find(el)
							.html(tmpContent);
					}
				}
			});
		}
	},
};

$.fn[pluginName] = function (options) {
	return this.each(function () {
		if (!$.data(this, 'plugin_' + pluginName)) {
			$.data(this, 'plugin_' + pluginName, new SectionLoader(this, options));
		}
	});
};
